
import viewRelateFlow from '@/components/browse/view-relate-flow';
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

import cusDateTime from '@/components/cusDateTime';
import selectSupply from '@/components/browse/select-supply';

export default {
name: "soa-view",
components: {viewRelateFlow, Grid, GridItem, Popup, cusDateTime, selectSupply},
props: ['dataId', 'component'],
data() {
return {
baseDto: {flowState: 'send'},
list: [],
index: 1,
show: false,
showList: [],
moreListBol: false,
isInner: false,
en: 0,
flowState: '',
bbsItem: {
bbsImageAttach: {
attachFile: []
}
},
TGvisible:false,
paymentDateDisabled:true,
showInvoiceDetails:false,
soaBillIdex:0
}
},
methods: {
itemTab(index) {
this.index = index;
if (index === 'flow') {
this.$emit('changeFlowInfo', true);
} else {
this.$emit('changeFlowInfo', false);
}
},
uploadSuccess(data) {
if (data) {
if (data.type.indexOf("png") != -1 || data.type.indexOf("PNG") != -1 || data.type.indexOf("jpg") != -1 || data.type.indexOf("JPG") != -1
|| data.type.indexOf("jpeg") != -1 || data.type.indexOf("JPEG") != -1 || data.type.indexOf("pdf") != -1 || data.type.indexOf("PDF") != -1) {
this.bbsItem.bbsImageAttach.attachFile[0] = data;
this.$post(`api/invoice-strategy/getTaxInvoiceByImag`, data).then((data) => {
if (data.length == 0) {
this.$message.error('上传成功但未获取至发票数据');
this.fileList = [];
} else {
this.$message.success('发票上传成功');
for (let i = 0; i < data.length; i++) {
this.billAdd(data, "upload");
this.updatePaymentTermData();
}

this.fileList = [];
}
}, () => {

}, () => {

});
} else {
this.$message.error('上传图片格式仅支持png、jpg、jpeg、pdf');
this.fileList = [];
return false;
}
}
},
openInvoiceDetails(i){
this.soaBillIdex = +(i.slice(0,i.length-1)) - 1
this.showInvoiceDetails = true;
},

billModalCancel(){
this.showInvoiceDetails = false;
},
billAdd(data, type) {

let num = 1;
this.baseDto.soaBillList.forEach(item => {
num++;
});
switch (type) {
case 'upload':
data[0].itemNo = num-1 + '0';
this.baseDto.soaBillList.push(data[0]);
break;
case 'add':
let soaBill = {
itemNo: num + '0',
checked: false,
billCode: '',
billExplain: '',
};
this.baseDto.soaBillList.push(soaBill);
break;
}
this.baseDto.soaBillList = [...this.baseDto.soaBillList];
this.baseDto.soaBillList = this.baseDto.soaBillList.filter(item => {
return item.attachment != null;
});
},
updatePaymentTermData() {
if (this.baseDto.paymentType == "1") {
let MaxDate;
let _MaxDate;
for (let i = 0; i < this.soaBillList.length; i++) {
let item = this.soaBillList[i];
if (i == 0) {
MaxDate = new Date(item.billDate).getTime();
this.baseDto.paymentTermData = item.billDate;
continue;
}
if (MaxDate < new Date(item.billDate).getTime()) {
MaxDate = new Date(item.billDate).getTime();
this.baseDto.paymentTermData = item.billDate;
}
}
if ((this.flowState == 'send' && this.baseDto.createUserIsSupplier == false) || this.flowState == 'billing') {
this.GetPaymentDateInfo(this.baseDto.soaDtList[0].paymentTerm);
}
}
},
GetPaymentDateInfo(paymentTerm) {
if (paymentTerm != null) {
switch (paymentTerm) {
case "B000":
this.paymentDateDisabled = false;
break;
/**
* 以下为发票日期的
*/
case "F001"://发票日期7天内（电汇）
this.GetMaxPaymentTimeCase1(7);
break;
case "F002"://发票日期15天内（电汇）
this.GetMaxPaymentTimeCase1(15);
break;
case "F003"://发票日期30天内（电汇）
this.GetMaxPaymentTimeCase1(30);
break;
case "F005"://发票日期60天内（电汇）
this.GetMaxPaymentTimeCase1(60);
break;
case "F007"://发票日期90天内（电汇）
this.GetMaxPaymentTimeCase1(90);
break;
case "F103"://发票日期30天内（承兑）
this.GetMaxPaymentTimeCase1(30);
break;
case "F105"://发票日期60天内（承兑）
this.GetMaxPaymentTimeCase1(60);
break;
case "YF01"://每月10日付款上月1-31日发票日期货款（电汇）
this.GetMaxPaymentTimeCase2(10, 1);
break;
case "YF02"://每月10日付款上上月1-31日发票日期货款（电汇）
this.GetMaxPaymentTimeCase2(10, 2);
break;
case "YF03"://每月25日付款上月1-31日发票日期货款（电汇）
this.GetMaxPaymentTimeCase2(25, 1);
break;
case "YF04"://每月25日付款上上月1-31日发票日期货款（电汇）
this.GetMaxPaymentTimeCase2(25, 2);
break;
case "YF11"://每月25日付款上月1-31日发票日期货款（承兑）
this.GetMaxPaymentTimeCase2(25, 1);
break;
case "YF12"://每月25日付款上上月1-31日发票日期货款（承兑）
this.GetMaxPaymentTimeCase2(25, 2);
break;
/**
* 以下为收货日期的
*/
case "Y001"://每月10日付款上月1-31日收货日期货款（电汇）
this.GetMaxPaymentTimeCase2(10, 1);
break;
case "Y002"://每月25日付款上月1-31日收货日期货款（电汇）
this.GetMaxPaymentTimeCase2(25, 1);
break;
case "Y003"://每月25日付款上上月1-31日收货日期货款（电汇）
this.GetMaxPaymentTimeCase2(25, 2);
break;
case "Y101"://每月10日付款上月1-31日收货日期货款（承兑）
this.GetMaxPaymentTimeCase2(10, 1);
break;
case "Y102"://每月25日付款上月1-31日收货日期货款（承兑）
this.GetMaxPaymentTimeCase2(25, 1);
break;
default:
this.paymentDateDisabled = false;
break;
}
}
},
GetMaxPaymentTimeCase2(day, month) {
let today = null;
if (this.baseDto.paymentTermData == null) {
today = new Date();
} else {
today = new Date(this.baseDto.paymentTermData);
}
let Month = today.getMonth() + month;
if (Month > 11) {
Month = Month - 11;
today.setFullYear(today.getFullYear() + 1);
}
today.setMonth(Month);
today.setDate(day);
this.baseDto.paymentDate = format(new Date(today.getTime()), 'YYYY-MM-DD');
this.paymentDateDisabled = true;
},
GetMaxPaymentTimeCase1(time) {
let today = null;
let day = 60 * 60 * 1000 * 24;
if (this.baseDto.paymentTermData == null) {
today = new Date().getTime();
} else {
today = new Date(this.baseDto.paymentTermData).getTime();
}
let lastTime = today + day * time;
this.baseDto.paymentDate = format(new Date(lastTime), 'YYYY-MM-DD');
this.paymentDateDisabled = true;
},
getBaseDto() {
this.$loadingShow();
this.$get('api/soa/' + this.dataId).then((data) => {
if (data) {
if (data.requestBase && data.requestBase.workflowNodeBase) {
this.flowState = data.requestBase.workflowNodeBase.actNodeId;
}
this.baseDto = data;
console.log(this.baseDto.createUserIsSupplier)
console.log(this.flowState)
this.list = data.samples;
this.showList = [];
this.getMore();
}
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
},
changeSoaDt(soaDt) {
if (soaDt.show) {
this.$set(soaDt, 'show', false);
return;
}
this.$set(soaDt, 'show', true);
},
changeClaim(claimDtDto) {
if (claimDtDto.show) {
this.$set(claimDtDto, 'show', false);
return;
}
this.$set(claimDtDto, 'show', true);
},
switchTabItem(e, info) {
e['list'] = info;
this.$forceUpdate();
},
showMore() {
this.show = true;
},
getMore() {
if (!this.baseDto.soaDtList) {
return;
}
let showLength = this.showList.length;
let moreLength = this.showList.length + 20;
if (this.baseDto.soaDtList.length > moreLength) {
for (let i = showLength; i < moreLength; i++) {
this.$set(this.baseDto.soaDtList[i], 'show', true);
this.showList.push(this.baseDto.soaDtList[i]);
}
} else {
for (let i = showLength; i < this.baseDto.soaDtList.length; i++) {
if (this.baseDto.soaDtList.length > 20) {
this.$set(this.baseDto.soaDtList[i], 'show', true);
}
this.showList.push(this.baseDto.soaDtList[i]);
}
}
if (this.showList.length >= this.baseDto.soaDtList.length) {
this.moreListBol = false;
} else {
this.moreListBol = true;
}
},
valid() {
let flag = false;

if((this.baseDto.createUserIsSupplier == false && this.flowState == 'send')
|| this.flowState == 'application'
|| this.flowState == 'billing'){
let _dtTotalPrice = 0;
let _dtTaxTotalPrice = 0;
for(let i = 0; i < this.baseDto.soaDtList.length; i++){
let sob = this.baseDto.soaDtList[i];
_dtTotalPrice += Number((sob.soaQty*sob.priceTaxInc).toFixed(2));
_dtTaxTotalPrice += Number((sob.soaQty*sob.jshsdj).toFixed(2));
}
let absToalPrice = Number(Math.abs(_dtTotalPrice - _dtTaxTotalPrice)/_dtTotalPrice);
if(absToalPrice > 0.003){
this.baseDto.threeOverThousand = "1";
}else{
this.baseDto.threeOverThousand = "0"
}
}

if (this.flowState == 'send' && this.baseDto.createUserIsSupplier == true) {

if(this.baseDto.buyerPersonName == null){
this.$message.error('对接采购员必填');
return false;
}
}

if(this.baseDto.flowState=='billing' || (this.baseDto.flowState == 'send' && this.baseDto.createUserIsSupplier == false ) || (this.baseDto.flowState == 'application' && this.baseDto.createUserIsSupplier == true)){
if(this.baseDto.paymentTermData == null){
this.$message.error('付款基准日期必填');
return false;
}
if(this.baseDto.paymentDate == null) {
this.$message.error('付款日期必填');
return false;
}
}

this.baseDto.soaBillList.forEach(element => {
if (element.billCode.length > 8) {
flag = true;
}
});
if (flag) {
/* this.$vux.toast.text('发票明细中的发票号码最多可输入8位');
return false*/
return true;
} else {
return true;
}

},
formData() {
return this.baseDto;
},
addBill() {
this.baseDto.soaBillList.push({
attachment: null,
billCode: '',
billExplain: null,
billPrice: null,
index: this.en++,
soaNo: null,
taxBillPrice: null,
taxPrice: null,
taxRate: null,
})
},
delBill(index) {
this.baseDto.soaBillList = this.baseDto.soaBillList.filter(item => {
return item.index != index;
});
},
delTGvisible(index){
this.baseDto.soaBillList = this.baseDto.soaBillList.filter(item => {
return item.machineAccountId != index;
});
},

billModalAdd(){
let index = this.soaBillIdex;
this.showInvoiceDetails = true;
let soaBillDt = {
invoiceMatter:'',
specificationMpdel: '',
unit: '',
quantiry: '',
excludeTaxAmount: 0,
includeTaxAmount: 0,
taxCode: '',
taxAmount: 0
};
this.baseDto.soaBillList[index].soaBillDtDtoList.push(soaBillDt);
this.baseDto.soaBillList[index].soaBillDtDtoList = [...this.baseDto.soaBillList[index].soaBillDtDtoList];
},

billModaldel(e){
e.quantiry = 'del'
this.baseDto.soaBillList[this.soaBillIdex].soaBillDtDtoList= this.baseDto.soaBillList[this.soaBillIdex].soaBillDtDtoList.filter(item => {
return item.quantiry != 'del';
});
},
addPrepaid(){

let nowCheck = [];
this.baseDto.soaAccountingList.forEach(item=>{
if (item.deleted == false && item.machineAccountId){
nowCheck.push(item.machineAccountId);
}
})
let data = {
soaId: null,
billCode: []
};
data.soaId = this.baseDto.id
data.billCode = nowCheck;
this.$post(`api/invoice-strategy/getPrepaidParameter`, data).then((res) => {
this.baseDto.soaBillList = res.list
this.TGvisible = true
}, () => {
}, () => {
});
},

selectSupplier() {
this.$refs.personRef.showPop();
},
getPerson(result) {
this.baseDto.buyerPerson = result;
this.baseDto.buyerPersonName = result.name;
this.baseDto.buyerPersonId = result.id;
}
},
mounted() {
if (this.dataId) {
this.getBaseDto()
}
this.isInner = this.$store.state.userType == 1;
},
watch: {
dataId() {
if (this.dataId) {
this.getBaseDto()
}
}
}
}



// WEBPACK FOOTER //
// ./src/page/soa/soa-view.vue